import type { ReceiptItem, UpdateReceiptItemParams } from '@/api/types/receipt'

import { FIELD_LABELS } from '../field-labels'
import { toNumberOrNull, toText } from '../field-value'
import { EditableField } from './editable-field'

type Props = {
  items: ReceiptItem[]
  /** `items.{line_no}.{field}` 形式で人が直した箇所が入る */
  editedFields: Set<string>
  onChange: (itemId: number, params: UpdateReceiptItemParams) => void
}

export const ReceiptItemTable = ({ items, editedFields, onChange }: Props) => {
  if (items.length === 0) return <p className="text-sm text-muted-foreground">明細がありません。</p>

  return (
    <div className="flex flex-col gap-3">
      {items.map((item) => {
        const isEdited = (field: string) => editedFields.has(`items.${item.line_no}.${field}`)
        return (
          <div key={item.id} className="flex flex-col gap-2 rounded border border-gray-700 p-2">
            {/* レシートに印字された文字列。突き合わせの基準なので編集させない */}
            <p className="text-xs text-muted-foreground">
              {item.line_no}. {item.raw_name}
            </p>
            <EditableField
              label={FIELD_LABELS.name}
              value={toText(item.name)}
              isEdited={isEdited('name')}
              onCommit={(value) => onChange(item.id, { name: value || null })}
            />
            <div className="grid grid-cols-2 gap-2">
              <EditableField
                label={FIELD_LABELS.generic_name}
                value={toText(item.generic_name)}
                isEdited={isEdited('generic_name')}
                onCommit={(value) => onChange(item.id, { generic_name: value || null })}
              />
              <EditableField
                label={FIELD_LABELS.category}
                value={toText(item.category)}
                isEdited={isEdited('category')}
                onCommit={(value) => onChange(item.id, { category: value || null })}
              />
              <EditableField
                label={FIELD_LABELS.quantity}
                type="number"
                value={toText(item.quantity)}
                isEdited={isEdited('quantity')}
                onCommit={(value) => onChange(item.id, { quantity: toNumberOrNull(value) })}
              />
              <EditableField
                label={FIELD_LABELS.unit_price}
                type="number"
                value={toText(item.unit_price)}
                isEdited={isEdited('unit_price')}
                onCommit={(value) => onChange(item.id, { unit_price: toNumberOrNull(value) })}
              />
              <EditableField
                label={FIELD_LABELS.amount}
                type="number"
                value={toText(item.amount)}
                isEdited={isEdited('amount')}
                onCommit={(value) => onChange(item.id, { amount: toNumberOrNull(value) })}
              />
              <EditableField
                label={FIELD_LABELS.discount}
                type="number"
                value={toText(item.discount)}
                isEdited={isEdited('discount')}
                onCommit={(value) => onChange(item.id, { discount: toNumberOrNull(value) })}
              />
            </div>
          </div>
        )
      })}
    </div>
  )
}
